import React from 'react'
// import ReactDatePicker from 'react-datepicker'

// const RadioButtonGroup = ({ ottTime, handleOttReleaseTime }) => {
//   // Define radio button options
//   const options = [
//     { id: 'ottDate', label: 'Date', value: 'date' },
//     { id: 'ottmonthAndYear', label: 'Month and Year', value: 'month' },
//     { id: 'ottyear', label: 'Year', value: 'year' },
//   ]

//   return (
//     <div
//       className='currentlyactive-style'
//       style={{ display: 'flex', gap: '10px' }}
//     >
//       {/* Dynamically generate radio buttons */}
//       {options.map(option => (
//         <React.Fragment key={option.id}>
//           <input
//             id={option.id}
//             type='radio'
//             name='currentlyactive'
//             value={option.value}
//             checked={ottTime === option.value}
//             onChange={handleOttReleaseTime}
//           />
//           <label htmlFor={option.id}>{option.label}</label>
//         </React.Fragment>
//       ))}
//       <br />
//     </div>
//   )
// }

const DateInput = ({ date, changeOttDate }) => (
  <>
    <label>Ott Released Date</label>
    <input
      type='date'
      value={date}
      placeholder='date'
      onChange={event => changeOttDate('date', event.target.value, 0)}
      className='form-control'
      style={{ width: '50%' }}
    />
  </>
)

// const MonthInput = ({ formattedMonthDate, changeOttDate }) => (
//   <>
//     <div className='d-flex gap-1'>
//       <div>
//         <label>Ott Released Month and Year</label>
//         <ReactDatePicker
//           dateFormat='yyyy/MM'
//           showMonthYearPicker
//           appearance='subtle'
//           selected={formattedMonthDate}
//           style={{ width: 200 }}
//           onChange={event => changeOttDate('month', event, 0)}
//         />
//       </div>
//       <div style={{ marginTop: '30px' }}>
//         <button
//           type='button'
//           className='btn btn-danger'
//           onClick={() => changeOttDate('month', '', 0)}
//         >
//           X
//         </button>
//       </div>
//     </div>
//   </>
// )

// const YearInput = ({ year, changeOttDate }) => (
//   <div className='d-flex gap-1'>
//     <div>
//       <label>Ott Released Year</label>
//       <ReactDatePicker
//         appearance='subtle'
//         selected={year}
//         onChange={date => changeOttDate('year', date.getFullYear(), 0)}
//         showYearPicker
//         dateFormat='yyyy'
//         yearItemNumber={9}
//       />
//     </div>
//     <div style={{ marginTop: '30px' }}>
//       <button
//         type='button'
//         className='btn btn-danger'
//         onClick={() => changeOttDate('year', '', 0)}
//       >
//         X
//       </button>
//     </div>
//   </div>
// )

const OttDateMonthYear = props => {
  const {
    /* sendBooleanValueChangeDone, sendinputdata,  inputData, */
    // ottTime,
    // handleOttReleaseTime,
    date,
    // formattedMonthDate,
    changeOttDate,
    // year,
    // Movielinks,
  } = props
  // const [streamingSoon, setStreamingSoon] = useState(false)

  // const handleStreamingSoonChange = event => {
  //   setStreamingSoon(event.target.checked)
  //   const inputvalue = { target: {
  //     value: null,
  //   } }
  //   handleOttReleaseTime(inputvalue)
  //   const inputDataTemp = { ...inputData }
  //   inputDataTemp.ottDateUi = event.target.checked
  //   sendBooleanValueChangeDone('ott', true)
  //   sendinputdata(inputDataTemp)
  // }

  // useEffect(() => {
    // setStreamingSoon(inputData.ottDateUi)
  // }, [inputData.ottDateUi])

  return (
    <DateInput date={date} changeOttDate={changeOttDate} />
   /*  <>
      {Movielinks &&
      Movielinks.length > 0 &&
      Movielinks.some(e => e.link && e.link !== '') ? (
        <>
          <div style={{ display: 'flex', gap: '4px' }}>
            <input
              type='checkbox'
              id='streamingSoonCheckbox'
              checked={streamingSoon}
              onChange={handleStreamingSoonChange}
            />
            <label htmlFor='streamingSoonCheckbox'>Streaming Soon</label>
          </div>
          { !streamingSoon && (
            <>
              <RadioButtonGroup
                ottTime={ottTime}
                handleOttReleaseTime={handleOttReleaseTime}
              />

              {Movielinks.some(e => e.link && e.link !== '') ? (
                ottTime === 'date' ? (
                  <DateInput date={date} changeOttDate={changeOttDate} />
                ) : ottTime === 'month' ? (
                  <MonthInput
                    formattedMonthDate={formattedMonthDate}
                    changeOttDate={changeOttDate}
                  />
                ) : ottTime === 'year' ? (
                  <YearInput year={year} changeOttDate={changeOttDate} />
                ) : null
              ) : null}
              <DateInput date={date} changeOttDate={changeOttDate} />
            </>
          )}
        </>
      ) : null}
    </> */
  )
}

export default OttDateMonthYear
